import React, { useState, useEffect } from "react";
import { useCartPageContext } from "../../../Context/CartTableContext";
import deleteIcon from "../../Assets/icon/delete.png";
import { useCartInventoryContext } from "../../../Context/Cache/CartInventoryContext";
import { toast} from "react-toastify";
import { nullRender } from "@fluentui/react"
 
 const CartGrid = () => {
  const { cartItems, setCartItems, deleteItem } = useCartPageContext();
  const { cartProduct, deleteProduct, setTotalPrice, setTotalMSRP, setCartProduct, deleteAllProducts,visibleColumns,visibleColumnsRepl,columns,columnsRepl } = useCartInventoryContext();
 
const handleQuantityChange = (index, newQuantity,service) => {
    const updatedCartProduct = cartProduct.map((item, i) => {
      if (i === index) {
        let quantity = 0; // Default to 0 if invalid
 
        if (newQuantity !== "" && !isNaN(newQuantity) && newQuantity > 0) {
          if (item.nyc_atuid !== undefined) {
            if (newQuantity > item.nyc_availablequantity && service !== 3) {
              toast.error("Requested Quantity cannot be more than the Available Quantity");
            }
            else {
              quantity = parseInt(newQuantity, 10);
            }
          }
          else if (item.incoming) {
            // Check against nyc_qtyonpo if incoming is true
            if (newQuantity > item.nyc_qtyonpo && service != 3) {
              toast.error("Requested Quantity cannot be more than the Incoming Quantity");
            } else {
              quantity = parseInt(newQuantity, 10);
            }}
          else {
            if (newQuantity > item.strava_availablequantity && service !== 3) {
              toast.error("Requested Quantity cannot be more than the Available Quantity");
            } else {
              quantity = parseInt(newQuantity, 10);
            }
          }
        }
       
        const updatedItem = { ...item, requestedQuantity: quantity };
        sessionStorage.setItem(`quantity-${index}`, quantity);
        return updatedItem;
      }
 
      return item;
    });
 
    setCartProduct(updatedCartProduct);
    calculateTotalPrice(updatedCartProduct);
    calculateTotalMSRP(updatedCartProduct);
  };
 
  const handleCounterOfferChange = (index, newCounterPrice) => {
    const updatedCartProduct = cartProduct.map((item, i) => {
      if (i === index) {
        let counterPrice ; // Default to 0 if invalid
 
        if (newCounterPrice !== "" && !isNaN(newCounterPrice)) {
          counterPrice = parseFloat(newCounterPrice);
          console.log(counterPrice);
        }
 
        const updatedItem = { ...item, counterOffer: counterPrice };
        sessionStorage.setItem(`counterOffer-${index}`, counterPrice);
        return updatedItem;
      }
      return item;
    });
    setCartProduct(updatedCartProduct);
    calculateTotalPrice(updatedCartProduct);
    calculateTotalMSRP(updatedCartProduct);
  };
 
 
 
  const calculateTotalPrice = (items) => {
    const totalPrice = items.reduce((acc, item) =>{
      if(item.nyc_atuid != undefined){
        return parseFloat(acc + (item.requestedQuantity || 0) * (item.nyc_price || 0))
      }
      return parseFloat(acc + (item.requestedQuantity || 0) * (parseFloat(item.counterOffer) || 0));
    }, 0)
    setTotalPrice(totalPrice);
    sessionStorage.setItem("totalPrice", totalPrice);
  };
 
  const calculateTotalMSRP = (items) => {
    const totalMSRP = items.reduce((acc, item) => acc + (item.requestedQuantity || 0) * (item.nyc_msrp || 0), 0);
    setTotalMSRP(totalMSRP);
    sessionStorage.setItem("totalMSRP", totalMSRP);
  };
 
  const handleDelete = (index) => {
    deleteProduct(index);
    sessionStorage.removeItem(`quantity-${index}`);
    sessionStorage.removeItem(`counterOffer-${index}`);
  };
 
  const handleDeleteAll = () => {
    deleteAllProducts();
    sessionStorage.clear();
    setTotalPrice(0);
    setTotalMSRP(0);
  };
 
return (
    <div className="col-lg-9 order-lg-2 nycfix-child-two">
      <div className="table-container box-border shadow-sm background-white max-h-screen overflow-auto">
        <table className="table-fixed min-w-full">
          <thead>
            <tr>
              <th className="w-10"></th>
              {cartProduct[0].nyc_atuid != undefined ? columnsRepl.map(
                (col) =>
                  visibleColumnsRepl.includes(col.key) && (
                    <th key={col.key} style={{ width: col.width }}>
                      {col.label}
                    </th>
                  )
              ) : columns.map(
                (col) =>
                  visibleColumns.includes(col.key) && (
                    <th key={col.key} style={{ width: col.width }}>
                      {col.label}
                    </th>
                  )
              )}
            </tr>
          </thead>
          <tbody>
            {cartProduct.map((product, index) => (
              product.nyc_atuid != null ?
              <>
              <tr className="bg-white border-b border-gray-300">{/* <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#FFF6F6]"}> */}
                <td>
                  <img
                    src={deleteIcon}
                    alt="Delete Icon"
                    className="ml-2"
                    onClick={() => deleteProduct(index)}
                    style={{ cursor: "pointer" }}
                  />
                </td>
                {visibleColumnsRepl.includes("image") && (
                  <td>
                    <img
                    // src={product.entityimage_url}
                    src={`https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${product.nyc_sku}.jpg`}
                    alt="Product" className="w-16 h-16 object-cover" />
                  </td>
                )}
                {visibleColumnsRepl.includes("sku") && <td>{product.nyc_sku}</td>}
                {visibleColumnsRepl.includes("brand") && <td>{product['_nyc_brand_value@OData.Community.Display.V1.FormattedValue']}</td>}
                {visibleColumnsRepl.includes("productName") && <td className="productName">{product.nyc_productname}</td>}
                {visibleColumnsRepl.includes("color") && <td>{product.nyc_name}</td>}
                {visibleColumnsRepl.includes("size") && <td>{product.size + " " + product.nyc_sizeuom}</td>} {/* Feedback change for UOM and gap */}
                {visibleColumnsRepl.includes("upcNumber") && <td>{product.nyc_upc}</td>}
                {visibleColumnsRepl.includes("availableQuantity") && <td>{product.nyc_availablequantity}</td>}
                {visibleColumnsRepl.includes("requestedQuantity") && (
                  <td>
                    <input
                      type="text"
                      value={product.requestedQuantity}
                      onChange={(e) => handleQuantityChange(index, e.target.value)}
                      className="width50"
                    />
                  </td>
                )}
                {/* {visibleColumnsRepl.includes("counterOffer") && (
                  <td>
                    <input
                      type="text"
                      value={product.counterOffer}
                      onChange={(e) => handleCounterOfferChange(index, e.target.value)}
                      className="width50"
                    />
                  </td>
                )} */}
                {visibleColumnsRepl.includes("price") && <td>${(product.nyc_price || 0).toFixed(2)}</td>}
                {/* {visibleColumnsRepl.includes("MSRP") && <td>${product.nyc_cost}</td>} */}
              </tr>
              </>
              :
              <>
              <tr className="bg-white border-b border-gray-300">{/* <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#FFF6F6]"}> */}
                <td>
                  <img
                    src={deleteIcon}
                    alt="Delete Icon"
                    className="ml-2"
                    onClick={() => deleteProduct(index)}
                    style={{ cursor: "pointer" }}
                  />
                </td>
                {visibleColumns.includes("image") && (
                  <td>
                    <img
                    // src={product.entityimage_url}
                    src={`https://nycdatastorage.blob.core.windows.net/productimage-uatcontainer/${product.productnumber}.jpg`}
                    alt="Product" className="w-16 h-16 object-cover" />
                  </td>
                )}
                {visibleColumns.includes("sku") && <td>{product.productnumber}</td>}
                {visibleColumns.includes("brand") && <td>{product.nyc_brand}</td>}
                 {visibleColumns.includes("productName") && <td className="productName">{product.name}</td>}
                {visibleColumns.includes("color") && <td>{product.nyc_color}</td>}
                {visibleColumnsRepl.includes("size") && <td>{product.size + " " + product.nyc_sizeuom}</td>}{/* Feedback change for UOM and gap */}
                {visibleColumns.includes("upcNumber") && <td>{product.nyc_upc}</td>}
               
                {visibleColumns.includes("availableQuantity") && (
                  <td>
                    {product.incoming ? product.nyc_qtyonpo : product.strava_availablequantity}
                  </td>
                )}
                {visibleColumns.includes("requestedQuantity") && (
                  <td>
                    <input
                      type="text"
                      value={product.requestedQuantity}
                      onChange={(e) => handleQuantityChange(index, e.target.value,product.producttypecode)}
                      className="width50"
                    />
                  </td>
                )}
                {visibleColumns.includes("price") && <td>${(product.price || 0).toFixed(2)}</td>}
                {visibleColumns.includes("MSRP") && <td>${(product.nyc_msrp || 0).toFixed(2)}</td>}
                {visibleColumns.includes("counterOffer") && (
                  <td>
                    <input
                      type="number"
                      value={product.counterOffer}
                      onChange={(e) => handleCounterOfferChange(index, e.target.value)}
                      step="0.01"
                    min={0}
                    className="border-1 pl-1"
                    style={{width:"75%"}}
                    />
                  </td>
                )}
              </tr> </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
 
export default CartGrid;